
import { createSlice } from "@reduxjs/toolkit"
import { merge } from "lodash";
import userSlice from "./userSlice";
import { scopeSlice } from "services/store/scopeSlice";
import { UserSettingsState } from "./userSettings.types";

const supportedLanguages = ["pl", "en"]

export const getBrowserLanguage = () => {

    let language: string | null | undefined;
    const localLangaue = localStorage.getItem("language");
    if (localLangaue) {
        //  console.log("Getting language from local storage", localLangaue);
        language = localLangaue;
    }
    if (!language) {
        // console.log("Getting language from navigator", navigator.language);
        language = navigator.language;
    }
    if (!language) {
        //   console.log("Defaulting to english");
        language = "en-US";
    }

    let l = language.split(/[-_]/)[0];

    const supportedLanguage = supportedLanguages.includes(l) ? l : "en";
    if (!supportedLanguage) {
        console.error("Unsupported language", language);
        return "en";
    }
    return supportedLanguage;
}

const setLangauge = (state: any, language: string, reason: string) => {
    //console.log("setting language", language, reason);
    if (state.interface) state.interface.language = language;
    localStorage.setItem("language", language);
}

export const initializeLanguage = () => {
    const language = getBrowserLanguage();
    localStorage.setItem("language", language);
    return language;
}

export const initialState: UserSettingsState = {
    general: {},
    subscriptions: {},
    interface: {
        language: initializeLanguage(),
        postListv2: {
            showPosts: true,
            showAOA: true,
            showDeleted: false,
            showHidden: false,
            providersFilter: {
                facebook: true,
                instagram: true,
                google: true
            },
            showWithActiveAds: false
        },
        creationList: {
            showPosts: true,
            showAOA: true,
            sort: "-combined",
            statusFilter: {
                removed: false,
                draft: true,
                published: true,
                scheduled: true
            },
            providersFilter: {
                facebook: true,
                instagram: true,
                google: true
            }
        },
        tasksList: {
            showPostRequest: true,
            showDataUpdate: true,
            statusFilter: {
                pendingAcceptation: true,
                accepted: true,
                rejected: true,
                returnedForCorrection: true,
                completed: true,
                scheduled: true,
            }
        },
        calculationsList: {
            paid: true,
            unpaid: true,
            calculations: true,
            teamCalculations: true
        },
        darkMode: false,
    },
    scope: {
        projectOpeningRule: undefined,
        lastProjectId: undefined,
        favoriteProjectId: undefined,
    },
    testing: {},
};





export const userSettingsSlice = createSlice({
    name: "userSettings",
    initialState: initialState,
    reducers: {
        get: (state, action) => {

            if (!action.payload) return;
            state.general = action?.payload?.data?.settings?.general;
            state.subscriptions = action?.payload?.data?.settings?.subscriptions;

            //remove existing language from interface
            if (action?.payload?.data?.settings?.interface?.language) delete action?.payload?.data?.settings?.interface?.language

            state.interface = {
                ...initialState.interface,
                ...action?.payload?.data?.settings?.interface,
            }

            state.scope = {
                ...initialState.scope,
                ...action?.payload?.data?.settings?.scope,
            }

            //if (userSettingsLanguage && userSettingsLanguage !== currentLanguage) setLangauge(state, userSettingsLanguage, "GET")
        },
        update: (state, action) => {
            return merge({}, state, action?.payload?.data?.settings)
        },
        localUpdate: (state, action) => {
            return merge({}, state, action.payload)
        },
        create: (state, action) => {
            return action?.payload?.data?.settings;
        },
        changeLanguage: (state, action) => {
            setLangauge(state, action?.payload?.language, "CHANGE_LANGUAGE")
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(userSlice.actions.getUser, (state, action) => {

                const settings = action?.payload?.included?.find((d: any) => d._type === "users_settings")?.settings;

                if (settings) {
                    state.interface = merge({}, initialState.interface, settings.interface);
                    state.scope = merge({}, initialState.scope, settings.scope);
                    state.general = merge({}, initialState.general, settings.general);
                    state.subscriptions = merge({}, initialState.subscriptions, settings.subscriptions);
                }

                if (action?.payload?.data?.language) setLangauge(state, action?.payload?.data?.language, "GET_USER")


            })
            .addCase(scopeSlice.actions.logout, () => {
                return initialState;
            })
    }
})


export default userSettingsSlice;